/* eslint-disable no-restricted-imports */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Interface } from 'ethers/lib/utils';
import { tokenTypes } from '../Fct/plugins/allowanceRequiredProtocols';
import { UniswapV3 as UniswapV3Helper } from '../Fct/plugins/uniswapV3/helpers/UniswapV3';
import { Tokens } from '../Fct/tokens/tokens';
import { ERRORS } from './errors';
import { FctParam, } from './generics';
import { getSwapPath, getTokenDecimals } from './getSwapPath';
import { getMethodInterface } from './helpers';
import { OneInchHelper as InchHelper } from './plugins/1inch/helpers';
import { AaveHelper } from './plugins/AaveV2/helpers/AaveHelper';
import { ChainLinkHelper } from './plugins/chainLink/helpers/ChainLinkHelper';
import { liquidity_method, method } from './plugins/FCT_UNISWAP/constants';
import { ParaswapHelper } from './plugins/paraswap/helpers/Paraswap';
import { Sushiswap as SushiswapHelper } from './plugins/sushiswap/helpers/Sushiswap';
import { Uniswap as UniswapHelper } from './plugins/uniswap/helpers/Uniswap';
import { getPluginsFromABI } from './plugins/utility/helpers/Utility';
import * as plugins from './pluginsExport';
import { Utils } from './tokens/Utils';
var availablePlugins = Object.keys(plugins).map(function (key) {
    var pluginKey = key;
    return plugins[pluginKey];
});
// type Plugin = Protocol[ProtocolKey]
var pluginsArray = [];
var pluginsMap = {};
var allPlugins = [];
var pluginsGroupKeys = ['type', 'protocol', 'method', 'methodInterface', 'methodInterfaceHash', 'name'];
availablePlugins.forEach(function (protocol) {
    var protocolType = protocol;
    Object.keys(protocolType).forEach(function (pluginType) {
        var type = pluginType;
        Object.keys(protocolType[type]).forEach(function (actionKey) {
            var protocolPlugins = protocolType[type];
            var key = actionKey;
            var Plugin = protocolPlugins[key];
            var plugin = new Plugin({ chainId: '1' });
            pluginsGroupKeys.forEach(function (key) {
                var value = plugin[key];
                if (!pluginsMap[value]) {
                    pluginsMap[value] = [];
                }
                pluginsMap[value].push({
                    name: plugin.name,
                    description: plugin.description,
                    plugin: Plugin,
                });
            });
            pluginsArray.push(Plugin);
        });
    });
});
pluginsArray.forEach(function (Plugin) {
    var plugin = new Plugin({ chainId: '1' });
    var _plugin = {
        name: plugin.name,
        description: plugin.description,
        plugin: Plugin,
    };
    allPlugins.push(_plugin);
});
var filterPlugins = function (_a) {
    var plugins = _a.plugins, key = _a.key, value = _a.value;
    return plugins.filter(function (Plugin) {
        var plugin = new Plugin.plugin({ chainId: '1' });
        if (plugin[key] === value)
            return true;
        return false;
    });
};
var excludePlugins = function (_a) {
    var plugins = _a.plugins, key = _a.key, value = _a.value;
    return plugins.filter(function (Plugin) {
        var plugin = new Plugin.plugin({ chainId: '1' });
        if (plugin[key] === value)
            return false;
        return true;
    });
};
var getPlugins = function (_a) {
    var e_1, _b;
    var by = _a.by, excludeBy = _a.excludeBy;
    if (!by && !excludeBy) {
        return allPlugins;
    }
    var plugins = undefined;
    for (var key in by) {
        var groupByKey = key;
        var value = by[groupByKey];
        if (!value)
            continue;
        if (plugins) {
            plugins = filterPlugins({ plugins: plugins, key: groupByKey, value: value });
        }
        else {
            plugins = pluginsMap[value] || [];
        }
    }
    for (var key in excludeBy) {
        var excludeByKey = key;
        var values = excludeBy[excludeByKey];
        if (!values)
            continue;
        try {
            for (var values_1 = (e_1 = void 0, __values(values)), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                var value = values_1_1.value;
                if (plugins && plugins.length) {
                    plugins = excludePlugins({ plugins: plugins, key: excludeByKey, value: value });
                }
                else {
                    plugins = excludePlugins({
                        plugins: allPlugins,
                        key: excludeByKey,
                        value: value,
                    });
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (values_1_1 && !values_1_1.done && (_b = values_1.return)) _b.call(values_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return plugins || [];
};
var useChainId = function (_a) {
    var plugin = _a.plugin, chainId = _a.chainId;
    if (plugin.chainId === chainId)
        return plugin;
    var params = plugin.toJSON();
    var plugins = getPlugins({
        by: { protocol: plugin.protocol, method: plugin.method, methodInterface: plugin.methodInterface },
    });
    var newPlugin = new plugins[0].plugin({ chainId: chainId });
    var isOk = newPlugin.fromJSON(params);
    if (isOk) {
        return newPlugin;
    }
    console.error('Failed to change chainId');
    return plugin;
};
var SWAP_WITHOUT_SLIPPAGE_METHOD = method;
var SIMPLE_ADD_LIQUIDITY_METHOD = liquidity_method;
export var getPluginInstanceFrom = function (_a) {
    var json = _a.json, chainId = _a.chainId, vaultAddress = _a.vaultAddress, walletAddress = _a.walletAddress, provider = _a.provider;
    var pluginParsed = JSON.parse(json);
    var plugins;
    try {
        plugins = getPlugins({
            by: {
                protocol: pluginParsed.protocol,
                name: pluginParsed.name,
            },
        });
    }
    catch (e) {
        console.error(e);
    }
    if (!plugins || !plugins.length) {
        var pluginInterface_1 = new Interface([
            "function ".concat(pluginParsed.contractInterface, " ").concat(pluginParsed.type === 'GETTER'
                ? 'view'
                : pluginParsed.inputWithMeta && 'value' in pluginParsed.inputWithMeta
                    ? 'payable'
                    : 'nonpayable', " ").concat(pluginParsed.contractInterfaceReturns),
        ]);
        var abi = Object.keys(pluginInterface_1.functions).map(function (key) { return pluginInterface_1.functions[key]; });
        if (!abi) {
            console.error("Abi creation for plugin ".concat(pluginParsed.protocol, " ").concat(pluginParsed.contractInterface, " failed"));
        }
        var inputTo = 'to' in pluginParsed.input ? pluginParsed.input.to : undefined;
        var to = typeof inputTo === 'string' ? inputTo : inputTo === null || inputTo === void 0 ? void 0 : inputTo.value;
        if (typeof to !== 'string') {
            throw new Error("Address \"to\" for ".concat(pluginParsed.protocol, " ").concat(pluginParsed.contractInterface, " not a string"));
        }
        plugins = getPluginsFromABI({
            protocol: pluginParsed.protocol,
            abi: abi,
            contractAddress: to,
            chainId: chainId,
            pluginName: pluginParsed.name,
        }).plugins;
    }
    if (!plugins)
        return undefined;
    var newPlugin = new plugins[0].plugin({ chainId: chainId, vaultAddress: vaultAddress, walletAddress: walletAddress, provider: provider });
    newPlugin.fromJSON(json);
    return { instance: newPlugin, details: plugins[0] };
};
export { allPlugins, AaveHelper, ChainLinkHelper, ERRORS, FctParam, getMethodInterface, getPlugins, getPluginsFromABI, getSwapPath, getTokenDecimals, InchHelper, ParaswapHelper, SIMPLE_ADD_LIQUIDITY_METHOD, SushiswapHelper, SWAP_WITHOUT_SLIPPAGE_METHOD, Tokens, tokenTypes, UniswapHelper, UniswapV3Helper, useChainId, Utils, };
export * from './pluginsExport';
export * from '../Fct/generics/FctParams';
export * from '../Fct/tokens';
